import {useAppDispatch} from '../../redux';
import {logoutDobroRu} from '../../redux/actions/dobroru';
import {useDialog} from '../components/modal/dialog';
import {DeviceSize, useDeviceSize} from '../theme/helpers';

export const useLogoutDobroRuDialog = (): (() => Promise<void>) => {
  const dialog = useDialog();
  const dispatch = useAppDispatch();
  const deviceSize = useDeviceSize();
  return async () => {
    dialog.showDialog({
      message: 'Вы действительно хотите отвязать учетную запись волонтера?',
      actions: [
        {
          title: 'Да',
          type: 'primary',
          closeModal: true,
          onPress: () => {
            dispatch(logoutDobroRu());
          },
        },
        {
          title: 'Нет',
          type: 'transparent',
          closeModal: true,
        },
      ],
      messageStyle: deviceSize === DeviceSize.desktop ? {marginBottom: 42} : {marginBottom: 30},
    });
  };
};
